/* Tap & Drill Selector — AIMS Industrial
   Recommendation logic is a direct port of AIMS_Tap_Drill_Selector.html, unchanged.
   Differences from the standalone file, all structural rather than behavioural:
     - data moved to assets/tap-drill-selector.json and fetched on load
     - element lookups scoped to the section root, so the section can be used twice on a page
     - inline styles moved to assets/tap-drill-selector.css
     - GA4 event on "Show recommendation"
   Nothing is added to window. */
(function () {
  'use strict';

  var cache = null;

  function loadData(url) {
    if (cache) return Promise.resolve(cache);
    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (d) { cache = d; return cache; });
  }

  function init(root) {
    var dataUrl = root.getAttribute('data-tds-data');
    var needName = 'tds-need-' + (root.getAttribute('data-tds-uid') || '1');
    var resultPanel = root.querySelector('[data-tds-result]');

    var TOOL_DATA = {}, NOTES = {}, THREAD_TYPES = [];




    var threadSel   = root.querySelector('[data-tds-thread]');
        var sizeSel     = root.querySelector('[data-tds-size]');
        var sizeLabel   = root.querySelector('[data-tds-size-label]');
        var materialSel = root.querySelector('[data-tds-material]');
        var methodSel   = root.querySelector('[data-tds-method]');
        var holeSel     = root.querySelector('[data-tds-hole]');
        var methodRow   = root.querySelector('[data-tds-method-row]');
        var holeRow     = root.querySelector('[data-tds-hole-row]');
        var resultEl    = root.querySelector('[data-tds-result]');
        var goBtn       = root.querySelector('[data-tds-go]');

    function getNeed(){
      var r = root.querySelector('input[name="' + needName + '"]:checked');
      return r ? r.value : 'tapdrill';
    }

    function currentSizes(){
      return TOOL_DATA[threadSel.value].sizes;
    }
    function currentData(){
      return TOOL_DATA[threadSel.value].data;
    }

    function populateSizes(){
      var sizes = currentSizes();
      sizeSel.innerHTML = sizes.map(function(s){ return '<option value="'+s+'">'+s+'</option>'; }).join('');
      sizeLabel.textContent = (threadSel.value === 'Metric Fine' || threadSel.value === 'BA') ? 'Thread size & pitch' : ((threadSel.value === 'UNC' || threadSel.value === 'UNF' || threadSel.value === 'BSW' || threadSel.value === 'BSF' || threadSel.value === 'BSB' || threadSel.value === 'BSP' || threadSel.value === 'BSPT' || threadSel.value === 'NPT' || threadSel.value === 'Rp' || threadSel.value === 'NPSF') ? 'Thread size & TPI' : 'Thread size');
    }

    function updateVisibility(){
      var need = getNeed();
      var material = materialSel.value;
      var hardened = material === 'hardened';
      var showMethod = need !== 'drillonly' && !hardened;
      methodRow.style.display = showMethod ? '' : 'none';
      holeRow.style.display = showMethod ? '' : 'none';
    }

    function productLine(p){
      return '<div class="tds-prod"><a href="'+p.u+'" target="_blank" rel="noopener noreferrer">'+p.t+'</a><div class="tds-blurb">'+p.b+'</div></div>';
    }
    function productList(arr, emptyMsg){
      if (!arr || arr.length === 0){ return '<div class="tds-empty">'+emptyMsg+'</div>'; }
      return arr.map(productLine).join('');
    }
    function collectionLink(name, slug){
      return '<a href="/collections/'+slug+'" target="_blank" rel="noopener noreferrer">Browse '+name+'</a>';
    }

    function tapSection(d, material, method, hole){
      var html = '<div class="tds-section-title">Tap</div>';
      var notes = [];

      if (method === 'hand'){
        if (d.handSet){
          html += '<div class="tds-subhead">3-piece set (Taper + Intermediate + Bottoming):</div>';
          html += productList([{t: d.handSet.label, u: d.handSet.url, b: 'Complete set — one of each'}]);
        } else {
          html += '<div class="tds-subhead">3-piece set:</div><div class="tds-empty">' + NOTES.noSetGeneric + '</div>';
        }
        html += '<div class="tds-subhead">Or individually:</div>';
        html += productList(d.handTaper, NOTES.noStockGeneric);
        html += productList(d.handBottoming, NOTES.noStockGeneric);
        if (material === 'stainless') notes.push(NOTES.stainlessHand);
        if (material === 'castiron') notes.push(NOTES.castironChips);
        if (d.handTapNote) notes.push(d.handTapNote);
      } else {
        var picks;
        if (material === 'mild' || material === 'castiron'){
          picks = (hole === 'blind') ? d.mildBlind : d.mildThrough;
          html += '<div class="tds-subhead">' + (hole === 'blind' ? 'Spiral Flute — pulls chips up and out, right for a blind hole:' : 'Spiral Point — pushes chips forward, right for a through hole:') + '</div>';
          if (material === 'castiron') notes.push(NOTES.castironChips);
          // Fixed 23/08/26 (BA build): this used to only fire for material==='mild' AND
          // hole==='blind', which silently dropped the note in two real cases -- (1) cast iron
          // hitting the same blind-hole spiral-point-substitution fallback as mild steel never
          // got the explanatory note either, across every prior thread type; (2) a genuine total
          // gap (no spiral point OR flute stocked at all, e.g. BSF's 7/32"/11/16", or BA overall)
          // showed nothing but the generic "we don't stock this" message in the THROUGH-hole view,
          // even though steelTapNote had the real explanation ready. Now fires whenever there's
          // something to say: the blind-substitution case (as before) or whenever picks is
          // genuinely empty regardless of hole type.
          if ((material === 'mild' || material === 'castiron') && d.steelTapNote && (hole === 'blind' || !picks.length)) notes.push(d.steelTapNote);
        } else if (material === 'aluminium'){
          picks = d.aluminium;
          html += '<div class="tds-subhead">Spiral Flute:</div>';
          notes.push(hole === 'blind' ? NOTES.aluminiumBlind : NOTES.aluminiumThrough);
          if (d.aluminiumTapNote) notes.push(d.aluminiumTapNote);
        } else if (material === 'stainless'){
          picks = d.stainless;
          html += '<div class="tds-subhead">Coated Spiral Flute:</div>';
          notes.push(d.stainlessTapNote ? NOTES.stainlessMachineNoCoated : NOTES.stainlessMachine);
          if (d.stainlessTapNote) notes.push(d.stainlessTapNote);
        }
        html += productList(picks, NOTES.noStockGeneric);
      }

      notes.forEach(function(n){ html += '<div class="tds-note">'+n+'</div>'; });
      return html;
    }

    function drillOneBlock(url, exact, note, label){
      if (!url) return '<div class="tds-empty">' + NOTES.noDrillGap + '</div>';
      var blurb = (exact ? 'Exact size match.' : NOTES.noExactDrillNote) + (note ? ' ' + note : '');
      return productList([{t: label, u: url, b: blurb}], '');
    }
    function cobaltBlock(url, label, exact, substituteNote){
      // substituteNote is set only when Stainless fell back to a general-purpose (non-cobalt) bit
      // because no D109 cobalt bit was close enough -- confirmed business decision, 26/08/26. When
      // set, it REPLACES the default "cobalt size match" blurb so the substitution is always
      // disclosed, never presented as if it were a genuine cobalt pick. Hardened steel never reaches
      // this function at all (render() short-circuits before drillSection() for material==='hardened'),
      // so this can't affect hardened's strict cobalt-or-nothing behaviour.
      if (url) return productList([{t: label, u: url, b: substituteNote ? substituteNote : (exact ? 'Exact size match' : 'Closest in-stock cobalt size')}], '');
      return '<div class="tds-empty">' + NOTES.cobaltGapNote + ' ' + collectionLink('Cobalt Drill Bits','cobalt-drill-bits') + ' — or call us and we will help you find the right one.</div>';
    }
    function dualDrillExtra(d){
      // Second drill target ("Drill & Reamer") plus the explanatory note and the actual stocked
      // reamer product, per Paul's "show both, explained" decision on BSPT's dual drill-column
      // mechanic. Only ever called when d.drillMMReamer is present -- every prior thread type's
      // records have no such field, so this whole path is inert for them.
      var html = '<div class="tds-note">' + NOTES.dualDrillExplainer + '</div>';
      html += '<div class="tds-subhead">Taper Pipe Reamer:</div>';
      if (d.reamerProduct){
        html += productList([d.reamerProduct], NOTES.noStockGeneric);
      } else {
        html += '<div class="tds-empty">' + (d.reamerNote || NOTES.noStockGeneric) + '</div>';
      }
      return html;
    }

    function drillSection(d, material){
      var html = '<div class="tds-section-title">Drill</div>';
      var dual = !!d.drillMMReamer;

      if (material === 'stainless'){
        if (dual){
          html += '<div class="tds-subhead">Drill Only:</div>' + cobaltBlock(d.cobaltDrillUrl, d.cobaltDrillLabel, d.cobaltExact, d.cobaltNote);
          html += '<div class="tds-subhead">Drill &amp; Reamer:</div>' + cobaltBlock(d.cobaltDrillReamerUrl, d.cobaltDrillReamerLabel, d.cobaltReamerExact, d.cobaltReamerNote);
          html += dualDrillExtra(d);
        } else {
          html += cobaltBlock(d.cobaltDrillUrl, d.cobaltDrillLabel, d.cobaltExact, d.cobaltNote);
        }
        return html;
      }

      var key = (material === 'castiron') ? 'castiron' : (material === 'aluminium' ? 'aluminium' : 'steel');
      if (dual){
        html += '<div class="tds-subhead">Drill Only:</div>' + drillOneBlock(d[key+'DrillUrl'], d[key+'DrillExact'], d[key+'DrillNote'], d[key+'DrillLabel']);
        html += '<div class="tds-subhead">Drill &amp; Reamer:</div>' + drillOneBlock(d[key+'DrillReamerUrl'], d[key+'DrillReamerExact'], d[key+'DrillReamerNote'], d[key+'DrillReamerLabel']);
        html += dualDrillExtra(d);
      } else {
        html += drillOneBlock(d[key+'DrillUrl'], d[key+'DrillExact'], d[key+'DrillNote'], d[key+'DrillLabel']);
      }
      return html;
    }

    function extractActualMM(label){
      // Every drill label built by the Python build scripts ends with the consistent suffix
      // " -- {tpi} TPI target Ø{actual_mm}mm", where actual_mm is the REAL stocked diameter that
      // was matched -- the theoretical target when pexact is true, but the nearest in-stock size
      // when it's false. Pulling it back out of the label here lets the header agree with
      // whichever product drillSection() is about to show, without touching all 11 build scripts.
      if (!label) return null;
      var m = /target \u00d8([\d.]+)mm\s*$/.exec(label);
      return m ? m[1] : null;
    }

    function headerDrillInfo(d, material){
      // Mirrors drillSection()'s own key selection (steel/aluminium/castiron, or cobalt for
      // stainless) so the header shows the SAME diameter as the product actually resolved for the
      // current material -- not the raw theoretical drillMM, which only equals the actual pick when
      // it happens to be an exact match. Falls back to the theoretical target whenever there's no
      // resolved label to read (e.g. a total drill gap), so a genuine gap still shows a sensible
      // number with no false "(closest available)" qualifier.
      var info = {mm: d.drillMM, mmExact: true, mmReamer: d.drillMMReamer, reamerExact: true};
      var key = (material === 'stainless') ? 'cobalt' : (material === 'castiron') ? 'castiron' : (material === 'aluminium') ? 'aluminium' : 'steel';
      var labelField = (key === 'cobalt') ? 'cobaltDrillLabel' : (key + 'DrillLabel');
      var exactField = (key === 'cobalt') ? 'cobaltExact' : (key + 'DrillExact');
      var actual = extractActualMM(d[labelField]);
      if (actual != null){ info.mm = actual; info.mmExact = !!d[exactField]; }
      if (d.drillMMReamer){
        var reamerLabelField = (key === 'cobalt') ? 'cobaltDrillReamerLabel' : (key + 'DrillReamerLabel');
        var reamerExactField = (key === 'cobalt') ? 'cobaltReamerExact' : (key + 'DrillReamerExact');
        var actualReamer = extractActualMM(d[reamerLabelField]);
        if (actualReamer != null){ info.mmReamer = actualReamer; info.reamerExact = !!d[reamerExactField]; }
      }
      return info;
    }

    function render(){
      var need = getNeed();
      var size = sizeSel.value;
      var material = materialSel.value;
      var method = (methodRow.style.display !== 'none') ? methodSel.value : 'machine';
      var hole = (holeRow.style.display !== 'none') ? holeSel.value : 'through';
      var d = currentData()[size];
      if (!d){ resultEl.innerHTML = ''; return; }

      var html = '<div class="tds-card">';
      // Hardened steel never reaches drillSection() (render() short-circuits below before any pick
      // is read), so there's no resolved product for the header to mirror there -- keep it on the
      // raw theoretical target in that case, same as before this fix.
      var info = (material === 'hardened') ? {mm: d.drillMM, mmExact: true, mmReamer: d.drillMMReamer, reamerExact: true} : headerDrillInfo(d, material);
      // Answer band. Same numbers and the same qualifier logic as before -- only the markup
      // changed, so the drill diameter can be the headline figure instead of being buried in
      // a sentence. Nothing below this point was touched.
      var qualify = function (exact) {
        return exact ? '' : '<span class="tds-answer__qual">closest available</span>';
      };
      var readout = function (label, mm, exact) {
        return '<div class="tds-answer__metric">' +
               '<span class="tds-answer__label">' + label + '</span>' +
               '<span class="tds-answer__mm">\u00d8' + mm + '<span class="tds-answer__unit">mm</span></span>' +
               qualify(exact) + '</div>';
      };
      var drillBlock = '';
      if (d.drillMMReamer) {
        drillBlock = readout('Tap drill &mdash; drill only', info.mm, info.mmExact) +
                     readout('Tap drill &mdash; drill &amp; reamer', info.mmReamer, info.reamerExact);
      } else if (d.drillMM) {
        drillBlock = readout('Tap drill', info.mm, info.mmExact);
      }
      html += '<div class="tds-answer">' +
                '<div class="tds-answer__metric tds-answer__metric--thread">' +
                  '<span class="tds-answer__label">Thread</span>' +
                  '<span class="tds-answer__size">' + threadSel.value + ' ' + size + '</span>' +
                '</div>' + drillBlock +
              '</div>';

      if (material === 'hardened'){
        html += '<div class="tds-note">' + NOTES.hardened + '</div>';
        html += helpFooter();
        html += '</div>';
        resultEl.innerHTML = html;
        return;
      }

      if (need !== 'drillonly'){ html += tapSection(d, material, method, hole); }
      if (need !== 'taponly'){ html += drillSection(d, material); }

      html += '<div class="tds-links">' + collectionLink('Taps','taps') + collectionLink('Jobber Drill Bits','jobber-drill-bits') + '</div>';
      html += helpFooter();
      html += '</div>';
      resultEl.innerHTML = html;
    }

    function helpFooter(){
      return '<div class="tds-help">' + NOTES.helpFooter + '</div>';
    }

    function refreshAfterVisibilityChange(){
      // Material / Method / Hole Type / Tap-Drill-Both all used to only call updateVisibility(),
      // which shows/hides form rows but never touches the result panel -- so if a result was
      // already on screen, it went stale silently until the user re-clicked "Show recommendation".
      // Fixed: same pattern Thread Type already used (update state AND re-render), applied here too.
      // Only re-render if a result is already showing -- never force a render before the user has
      // shown one at least once via the button (in practice the panel is filled on initial load, so
      // this check simply keeps that behaviour intact rather than skipping a render it shouldn't).
      updateVisibility();
      if (resultEl.innerHTML.trim() !== ''){ render(); }
    }

    threadSel.addEventListener('change', function(){ populateSizes(); updateVisibility(); render(); });
    Array.prototype.forEach.call(root.querySelectorAll('input[name="' + needName + '"]'), function (r) {
          r.addEventListener('change', refreshAfterVisibilityChange);
        });
    materialSel.addEventListener('change', refreshAfterVisibilityChange);
    methodSel.addEventListener('change', refreshAfterVisibilityChange);
    holeSel.addEventListener('change', refreshAfterVisibilityChange);
    goBtn.addEventListener('click', render);


    function track() {
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'tap_drill_lookup', {
        thread_type: threadSel.value,
        thread_size: sizeSel.value,
        material: materialSel.value
      });
    }
    goBtn.addEventListener('click', track);

    goBtn.disabled = true;
    if (resultPanel) {
      resultPanel.innerHTML = '<div class="tds__loading">Loading tap and drill data…</div>';
    }

    loadData(dataUrl).then(function (payload) {
      TOOL_DATA = payload.data;
      NOTES = payload.notes;
      THREAD_TYPES = payload.threadTypes;
      goBtn.disabled = false;
      populateSizes();
      updateVisibility();
      render();
    }).catch(function (err) {
      goBtn.disabled = false;
      if (resultPanel) {
        resultPanel.innerHTML = '<div class="tds-empty">Couldn\u2019t load the tap and drill data. ' +
          'Please refresh the page, or <a href="/pages/contact-us">contact us</a> and we\u2019ll ' +
          'work it out with you.</div>';
      }
      if (window.console) window.console.error('[tap-drill-selector]', err);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-tds]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-tds-ready') === '1') continue;
      roots[i].setAttribute('data-tds-ready', '1');
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
